import React, { useState } from "react"
import PropTypes from "prop-types"
import { Box } from "@infotech/uikit-grid"
import noop from "lodash/noop"
import isEqual from "lodash/isEqual"
import { WarningOutlineIcon, LeftIcon, RightIcon } from "@infotech/uikit-icons"
import styles from "./styles.css"

const warningColor = opacity => `rgba(253, 216, 53, ${opacity || 1})`
const errorColor = opacity => `rgba(255, 116, 106, ${opacity || 1})`

const isError = message => message.level === `ERROR`

const ValidateCarousel = ({ errors }) => {
  const [errorPosition, toggleError] = useState(0)
  const moreThenOneError =
    errors && errors.violations && errors.violations.length > 1
  const rightArrowActive = !isEqual(errorPosition, errors.violations.length - 1)
  const leftArrowActive = !isEqual(errorPosition, 0)
  return (
    <>
      <Box
        flex
        loose
        style={{
          backgroundColor: isError(errors.violations[errorPosition])
            ? errorColor(`0.1`)
            : warningColor(`0.24`),
        }}
      >
        <Box w="56px" loose className={styles.IconWrapper}>
          <WarningOutlineIcon
            color={
              isError(errors.violations[errorPosition])
                ? errorColor()
                : warningColor()
            }
          />
        </Box>
        <Box loose flex column className={styles.MessageWrapper}>
          <Box loose className={styles.MessageHeader}>
            {isError(errors.violations[errorPosition])
              ? `Ошибка`
              : `Предупреждение`}
          </Box>
          <Box loose className={styles.MessageBody}>
            {errors.violations[errorPosition].message}
          </Box>
        </Box>
        <Box loose pt="2md" flex className={styles.arrowWrapper}>
          <Box
            loose
            onClick={() =>
              leftArrowActive ? toggleError(errorPosition - 1) : noop
            }
            pr="1md"
          >
            {moreThenOneError && (
              <LeftIcon
                size="small"
                className={
                  leftArrowActive ? styles.arrowActive : styles.disabledArrow
                }
              />
            )}
          </Box>
          <Box
            loose
            onClick={() =>
              rightArrowActive ? toggleError(errorPosition + 1) : noop
            }
            pr="2md"
          >
            {moreThenOneError && (
              <RightIcon
                size="small"
                className={
                  rightArrowActive ? styles.arrowActive : styles.disabledArrow
                }
              />
            )}
          </Box>
        </Box>
      </Box>
    </>
  )
}

ValidateCarousel.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      violations: PropTypes.arrayOf(
        PropTypes.shape({
          level: PropTypes.string.isRequired,
          message: PropTypes.string.isRequired,
        }),
      ),
      error: PropTypes.bool,
    }),
  ).isRequired,
}

export default ValidateCarousel
